/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actionTypes from './actionTypes';

const initialState = {
  errorMessageInRedux: [],
  labelerDifferences: [],
  contractDifferences: [],
  contactDifferencesMfg: [],
  contactDifferencesCms: [],
  singleLabelerData: {},
  inputValue: 1,
  mfgId: '',
  labelerDiffTabObj: {},
  checkedValue: [],
  tabValue: 'one',
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.HANDLE_ERROR_MSG_LB:
      return { ...state, errorMessageInRedux: action.payload };
    case actionTypes.GET_LABELER_DIFFERENCES:
      return { ...state, labelerDifferences: action.payload };
    case actionTypes.GET_LABELER_DIFFERENCES_CONTRACT:
      return { ...state, contractDifferences: action.payload };
    case actionTypes.GET_CONTACT_DIFFERENCES_MFG:
      return { ...state, contactDifferencesMfg: action.payload };
    case actionTypes.GET_CONTACT_DIFFERENCES_CMS:
      return { ...state, contactDifferencesCms: action.payload };
    case actionTypes.INPUT_FIELD_VALUE:
      return { ...state, inputValue: action.payload };
    case actionTypes.MFG_ID:
      return { ...state, mfgId: action.payload };
    case actionTypes.SINGLE_LABELER_DATA:
      return { ...state, singleLabelerData: action.payload };
    case actionTypes.LABELER_DIFF_TAB_DATA:
      return { ...state, labelerDiffTabObj: action.labelerDiffTabObj };
    case actionTypes.GET_CHECKED_VALUE:
      return { ...state, checkedValue: action.payload };
    case actionTypes.GET_TAB_VALUE:
      return { ...state, tabValue: action.payload };
    case actionTypes.CLEAR_REDUX_LALELAR_DIFF:
      return [];

    default:
      return state;
  }
};
export default reducer;
